// Minimal CSV exporter used by report pages. Keeps field escaping and file
// download in one place so callers stay one-liners.

export function escapeField(value: unknown): string {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(',') || str.includes('"') || str.includes('\n') || str.includes('\r')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export interface CsvColumn<T> {
  header: string;
  get: (row: T) => unknown;
}

export function downloadCsv<T>(filename: string, columns: CsvColumn<T>[], rows: T[]): void {
  const header = columns.map((c) => escapeField(c.header)).join(',');
  const body = rows
    .map((row) => columns.map((c) => escapeField(c.get(row))).join(','))
    .join('\n');
  const content = `${header}\n${body}`;
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

/**
 * Shared stub for share-via-WhatsApp/Email/PDF.
 * Today it routes to `window.open(...)` with a pre-filled message; the real
 * wiring will land when the notification service endpoints are built.
 */
export function shareReportLink(channel: 'whatsapp' | 'email', title: string, summary: string): void {
  const text = encodeURIComponent(`${title}\n\n${summary}\n\n— Orio360`);
  if (channel === 'whatsapp') {
    window.open(`https://wa.me/?text=${text}`, '_blank', 'noopener');
    return;
  }
  window.open(`mailto:?subject=${encodeURIComponent(title)}&body=${text}`, '_blank', 'noopener');
}
